import Vue from 'vue'
import VueResource from 'vue-resource'
import Vuex from 'vuex'

Vue.use(VueResource)
Vue.use(Vuex)

export default new Vuex.Store({
  actions: {
    getStudent ({ commit, getters }, student) {
      return new Promise((resolve, reject) => {
        if (getters.studentById(student.id)) {
          resolve()
        } else {
          Vue.http.post('static/api.php/person', student).then(
            success => {
              commit('addStudent', success.data)
              resolve()
            },
            error => { reject(error) }
          )
        }
      })
    },
    listSemesters ({ commit }) {
      Vue.http.get('static/api.php/semesterlist').then(
        success => { commit('updateSemesters', success.data) },
        error => { console.log(error) }
      )
    },
    listSources ({ commit }) {
      Vue.http.get('static/api.php/sourcelist').then(
        success => { commit('updateSources', success.data) },
        error => { console.log(error) }
      )
    },
    searchStudents ({ commit, getters }) {
      Vue.http.post('static/api.php/person_list', getters.search).then(
        success => { commit('updateFound', success.data) },
        error => { console.log(error) }
      )
    }
  },
  getters: {
    found (state) { return state.found },
    search (state) { return state.search },
    semesters (state) { return state.semesters },
    sources (state) { return state.sources },
    studentById: (state) => (id) => {
      return state.objects[id]
    }
  },
  mutations: {
    addStudent (state, payload) {
      state.objects[payload.id] = payload
    },
    updateFound (state, payload) {
      state.found = payload
    },
    updateSemesters (state, payload) {
      state.semesters = payload.semesters
    },
    updateSources (state, payload) {
      state.sources = payload.sources
    }
  },
  state: {
    found: [],
    objects: {},
    search: {firstname: '', lastname: '', origin: '', semester: '', faculty: ''},
    semesters: [],
    sources: []
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js